/**
 * custom-image-toggle.js
 * 「ディティールはこちら」セクション（.cyclo-lp-detail）用
 */

(function() {
  'use strict';

  /* ========================
  * バナー背景画像の切替処理
  * ======================== */
  function initImageToggle(sectionEl) {
    // バナー背景画像の取得
    var backgroundMediaEl = sectionEl.querySelector('.banner__media');
    if (!backgroundMediaEl) return;

    preloadDetailImages(sectionEl);

    // ディティール内選択ボタンのクリック時の処理
    sectionEl.querySelectorAll('[data-image-pc]').forEach(function(button) {
      
      button.addEventListener('click', function() {
        var imageUrlDesktop = button.getAttribute('data-image-pc');
        var imageUrlMobile = button.getAttribute('data-image-sp');
        if (!imageUrlDesktop) return;

        // アコーディオン 閉じるボタン押下時は背景画像の切替えを行わない
        if (button.classList.contains('minus_icon')) return;

        // バナー背景画像の切替え
        applyBackgroundImage(backgroundMediaEl, imageUrlDesktop, imageUrlMobile);
      });
    });
  }

  // トグル用画像をページ読み込み時に事前取得
  function preloadDetailImages(sectionEl) {
    var preloadedUrls = {};

    sectionEl.querySelectorAll('[data-image-pc]').forEach(function(toggleButton) {
      var imageUrls = [
        toggleButton.getAttribute('data-image-pc'),
        toggleButton.getAttribute('data-image-sp')
      ];

      imageUrls.forEach(function(imageUrl) {
        if (!imageUrl || preloadedUrls[imageUrl]) return;

        preloadedUrls[imageUrl] = true;
        var preloadImage = new Image();
        preloadImage.loading = 'eager';
        preloadImage.src = imageUrl;
      });
    });
  }

  function applyBackgroundImage(backgroundMediaEl, imageUrlDesktop, imageUrlMobile) {
    // PCとSPでそれぞれ切替え
    switchBackgroundImage(backgroundMediaEl, 'banner--media-desktop', imageUrlDesktop);
    switchBackgroundImage(backgroundMediaEl, 'banner--media-mobile', imageUrlMobile || imageUrlDesktop);
  }

  // バナー背景画像の切替
  function switchBackgroundImage(backgroundMediaEl, mediaClass, nextSrc) {
    var currentEl = backgroundMediaEl.querySelector('.' + mediaClass + '.show'); // 表示中の背景画像
    var nextEl = backgroundMediaEl.querySelector('.' + mediaClass + ':not(.show)'); // 次の背景画像

    // 同じ背景画像なら何もしない
    if (currentEl) {
      var link = document.createElement('a');
      link.href = nextSrc;
      if (currentEl.src === link.href) return;
    }

    // 次の背景画像がない場合は作成
    if (!nextEl) {
      nextEl = document.createElement('img');
      nextEl.className = mediaClass;
      backgroundMediaEl.appendChild(nextEl);
    }

    nextEl.setAttribute('loading', 'eager');
    nextEl.src = nextSrc;

    if (currentEl) {
      currentEl.classList.remove('show');
      currentEl.classList.add('hide');
    }

    nextEl.classList.remove('hide');
    nextEl.classList.add('show');
  }

  /* ========================
  * アコーディオン開閉処理
  * ======================== */
 
  function initAccordion(sectionEl) {
    // 各アコーディオンの開閉対象の要素をループ
    sectionEl.querySelectorAll('[data-group-id="detail_info"]').forEach(initAccordionItem);
  }

  // アコーディオン化
  function initAccordionItem(accordionItem) {
    if (accordionItem.classList.contains('control-item')) return; // 既にアコーディオン化されている場合は終了
    accordionItem.classList.add('control-item');

    // アコーディオン化対象の要素を取得
    var toggleButton  = accordionItem.querySelector('.grid__item .button, .grid__item [role="button"]');
    var hasContent = accordionItem.querySelectorAll('.grid__item').length >= 2;
    if (!toggleButton || !hasContent) return;

    toggleButton.classList.add('control-item-open');

    // 初回はアコーディオンアイコンを閉じる
    setAccordionIcon(toggleButton, false);

    // アコーディオンクリック時の処理
    toggleButton.addEventListener('click', function() {
      toggleAccordionItem(accordionItem, toggleButton);
    });
  }

  // アコーディオンクリック時の処理
  function toggleAccordionItem(accordionItem, toggleButton) {
    // クリックした項目以外のアコーディオンを閉じる
    closeOtherAccordionItems(accordionItem);

    // クリックした項目のアコーディオンを開く
    var isOpen = accordionItem.classList.toggle('expanded');
    setAccordionIcon(toggleButton, isOpen);

    // スマホの場合はnext・prevボタンを表示
    if (window.innerWidth <= 768) {
      setNextPrevButton(accordionItem, isOpen);
      if (!isOpen) {
        requestAnimationFrame(function() {
          accordionItem.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'instant' });
        });
      }
    }
  }

  // アコーディオンアイコンの切替
  function setAccordionIcon(toggleButton, open) {
    toggleButton.classList.remove('plus_icon', 'minus_icon');
    toggleButton.classList.add(open ? 'minus_icon' : 'plus_icon');
  }

  // クリックした項目以外のアコーディオンを閉じる
  function closeOtherAccordionItems(clickedItem) {
    var buttonGroup = clickedItem.closest('.detail_button_group');
    if (!buttonGroup) return;

    buttonGroup.querySelectorAll('[data-group-id="detail_info"]').forEach(function(item) {
      if (item === clickedItem) return;

      item.classList.remove('expanded');
      var toggleButton = item.querySelector('.control-item-open');
      if (toggleButton) setAccordionIcon(toggleButton, false);
    });
  }

  // next・prevボタンの処理
  function setNextPrevButton(accordionItem, isOpen) {
    accordionItem.querySelectorAll('.next_button, .prev_button').forEach(
      function(btn) { 
        // 既存ボタンを削除
        accordionItem.removeChild(btn); 
      });
    
    // アコーディオンが閉じている場合はボタンを非表示
    if (!isOpen) return;

    var CHEVRONS = {
      prev: 'https://cdn.shopify.com/s/files/1/0973/6853/9458/files/ChevronLeft.svg?v=1773657665',
      next: 'https://cdn.shopify.com/s/files/1/0973/6853/9458/files/ChevronRight.svg?v=1773657648'
    };
    var wrapperItem = accordionItem.parentElement;
    const PREV_NUM = -1;
    const NEXT_NUM = 1;

    // next・prevボタンを追加
    function addNavButton(name, num) {
      var sibling = num === PREV_NUM ? wrapperItem.previousElementSibling : wrapperItem.nextElementSibling;

      var slideButton = document.createElement('button');
      slideButton.className = name + '_button';
      slideButton.setAttribute('aria-label', num === PREV_NUM ? '前へ' : '次へ');
      if (!sibling) slideButton.disabled = true;

      var img = document.createElement('img');
      img.src = CHEVRONS[name];
      img.width = img.height = 24;
      img.alt = '';
      slideButton.appendChild(img);

      slideButton.addEventListener('click', function() {
        var toggleButton = sibling ? sibling.querySelector('[data-group-id="detail_info"] .control-item-open') : null;
        if (toggleButton) toggleButton.click();
      });
      accordionItem.appendChild(slideButton);
    }

    addNavButton('prev', PREV_NUM);
    addNavButton('next', NEXT_NUM);
  }

  // --- 初期化 ---
  function init() {
    var sectionEl = document.querySelector('.cyclo-lp-detail');
    if (sectionEl) {
      initImageToggle(sectionEl); // 画像切替え処理
      initFadeIn(sectionEl.id); // フェードイン処理
      initAccordion(sectionEl); // アコーディオン開閉処理
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
